import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/dms`;

/** 社内側（要ログイン）。 */
export const shareApi = {
  create: (body) => axios.post(`${API}/shares`, body).then((r) => r.data),
  newPassword: () => axios.get(`${API}/share-password`).then((r) => r.data),
  list: (scope = 'mine', status = '') =>
    axios.get(`${API}/shares`, { params: { scope, status } }).then((r) => r.data),
  detail: (sid) => axios.get(`${API}/shares/${sid}`).then((r) => r.data),
  extend: (sid, days) => axios.post(`${API}/shares/${sid}/extend`, { days }).then((r) => r.data),
  reissue: (sid) => axios.post(`${API}/shares/${sid}/password`).then((r) => r.data),
  revoke: (sid) => axios.delete(`${API}/shares/${sid}`).then((r) => r.data),
  counts: (ids) => axios.get(`${API}/shares/counts`,
    { params: { document_ids: ids.join(',') } }).then((r) => r.data),
};

/** 公開側（ログイン不要・トークンとパスワードだけ）。
 *  共通の axios は 401 でログイン画面へ飛ばすため、素の instance を使う。 */
const pub = axios.create();

export const publicShareApi = {
  unlock: (token, password) =>
    pub.post(`${API}/s/${token}/unlock`, { password }).then((r) => r.data),
  view: (token, session) =>
    pub.get(`${API}/s/${token}`, { params: { session } }).then((r) => r.data),
  fileUrl: (token, did, session, download = false) =>
    `${API}/s/${token}/file/${did}?session=${encodeURIComponent(session)}${download ? '&download=true' : ''}`,
  // 画面に出すときはAPIを直接 iframe に入れない（X-Frame-Options で拒まれる）。
  // 中身を取ってきて blob の URL にしてから表示する。
  fileBlob: (token, did, session) =>
    pub.get(`${API}/s/${token}/file/${did}`, { params: { session }, responseType: 'blob' })
      .then((r) => r.data),
  zipUrl: (token, session) => `${API}/s/${token}/zip?session=${encodeURIComponent(session)}`,
};

const HONORIFIC_END = ['様', '殿', '御中', '各位'];

/** 相手先の書き方に合わせて敬称を足す（すでに付いていれば足さない）。 */
export const withHonorific = (name) => {
  const n = (name || '').trim();
  if (!n) return '';
  return HONORIFIC_END.some((h) => n.endsWith(h)) ? n : `${n}様`;
};

export const SHARE_STATUS = {
  active: { label: '有効', cls: 'bg-teal-50 text-teal-700 border-teal-200' },
  expired: { label: '期限切れ', cls: 'bg-zinc-100 text-zinc-500 border-zinc-200' },
  revoked: { label: '停止', cls: 'bg-rose-50 text-rose-700 border-rose-200' },
  limit_reached: { label: '回数上限', cls: 'bg-amber-50 text-amber-800 border-amber-300' },
};

export default shareApi;
